import update from 'immutability-helper';

import {
  UPDATED_SAVED_LIST,
  DELETED_SAVED_LIST,
  ADD_TRACK_TO_SAVED_LIST,
  REMOVE_TRACK_FROM_SAVED_LIST,

  ADD_SPEAKER_SUBSCRIBE_IDS,
  FOR_ME_LOADING_COUNT_DECREASE,
  FOR_ME_LOADING_COUNT_INCREASE,
  FOR_ME_LOAD_FAILED,
  FOR_ME_PREFERENCE_SAVE_STARTED,
  FOR_ME_PREFERENCE_SAVE_FINISHED,
  FOR_ME_PREFERENCE_REFRESH_REQUESTED,
  FOR_ME_PREFERENCE_REFRESH_READY,
  FOR_ME_PREFERENCE_REFRESH_FAILED,
  FOR_ME_PREFERENCE_REFRESH_APPLIED,
  FOR_ME_PREVIEW_SEEN,
  LOAD_TOPIC_PREFERENCES,
  LOAD_LATEST_SUBSCRIED,
  LATEST_SUBSCRIBED_LOAD_FAILED,
  INVALIDATE_LATEST_SUBSCRIBED,
  LOAD_RECENTLY_PLAYED,
  LOAD_RECENTLY_SAVED,
  SAVE_TRACK_MUTATION_FINISHED,
  SAVE_TRACK_MUTATION_STARTED,
  SET_AUTHENTICATED,
  SET_AUTH_RESTORE_ERROR,
  SET_FOR_ME,
  SET_GET_STARTED_TOPICS_STATUS_TRUE,
  SET_LATEST_SUBSCRIED,
  SET_PODCAST_SUBSCRIBE_STATUS,
  SET_RECENTLY_PLAYED,
  SET_RECENTLY_SAVED,
  SET_SAVE_TRACK_STATUS,
  SET_SPEAKER_SUBSCRIBE_STATUS,
  SET_UNAUTHENTICATED,
  SET_USER,
  SYNC_SUBSCRIBE_STATUSES,
  SYNC_TOPIC_PREFERENCES,
  TOPIC_PREFERENCE_MUTATION_FINISHED,
  TOPIC_PREFERENCE_MUTATION_ROLLED_BACK,
  TOPIC_PREFERENCE_MUTATION_STARTED,
  TOPIC_PREFERENCES_LOAD_FAILED,
  TOPIC_PREFERENCES_LOADED,
} from '../types';
import {
  applySubscribeStatus,
  applySubscribeStatusEntries,
  normalizeSubscribeStatusById,
  subscribeIdsFromStatusById,
  subscribeStatusMapFromIds,
} from '../../utils/subscribeStatus';

const initialTopicPreferencesState = {
  topicPreferenceStatusById: {},
  topicPreferencesError: null,
  topicPreferencesLoaded: false,
  topicPreferencesLoading: false,
  topicPreferencesRequestId: null,
  topicPreferencesRevision: 0,
  topicPreferenceRevisionById: {},
  topicPreferencePendingMutationById: {},
};

const initialState = {
  authenticated: null,
  authRestoreError: null,
  forMeLoadingCount: 0,
  forMePreviewsData: null,
  forMeLoadError: null,
  forMeSessionRevision: 0,
  forMePreferenceRevision: 0,
  forMePreferenceSaves: {},
  forMePreferenceBoostTopicIds: [],
  preferenceFeedRefreshState: 'idle',
  preparedForMeData: null,
  preparedForMeRevision: null,
  forMeSeenPreviewIds: {},
  forMeDismissedInitialPreviewIds: {},
  getStartedTopicsStatus: null,
  latestSubscribedData: null,
  latestSubscribedLoading: false,
  latestSubscribedRefreshReason: 'automatic',
  latestSubscribedError: false,
  latestSubscribedFailedAt: null,
  latestSubscribedInvalidationRevision: 0,
  latestSubscribedRequestId: null,
  phoneNumber: '',
  podcastSubscribeIds: [],
  podcastSubscribeStatusById: {},
  entityPreferenceEdits: {},
  recentlyPlayedData: null,
  recentlyPlayedLoading: false,
  recentlySavedData: null,
  recentlySavedLoading: false,
  saveTrackMutationCount: 0,
  speakerSubscribeIds: [],
  speakerSubscribeStatusById: {},
  savedLists: [],
  savedListRevision: 0,
  savedListRevisionById: {},
  savedTrackIdToSavedListIds: {},
  ...initialTopicPreferencesState,
  uid: '',
};


const addSpeakerSubscribeIds = (speakerSubscribeIds, newSpeakerSubscribeIds) => {
  return [...new Set([...speakerSubscribeIds, ...newSpeakerSubscribeIds])]
};

const normalizeUserSubscribeState = (payload = {}) => {
  const speakerSubscribeStatusById = normalizeSubscribeStatusById(
    payload.speakerSubscribeStatusById,
    payload.speakerSubscribeIds,
  );
  const podcastSubscribeStatusById = normalizeSubscribeStatusById(
    payload.podcastSubscribeStatusById,
    payload.podcastSubscribeIds,
  );

  return {
    ...payload,
    speakerSubscribeStatusById,
    podcastSubscribeStatusById,
    speakerSubscribeIds: subscribeIdsFromStatusById(speakerSubscribeStatusById),
    podcastSubscribeIds: subscribeIdsFromStatusById(podcastSubscribeStatusById),
  };
};


export default function (state = initialState, action) {
  if (action.type === UPDATED_SAVED_LIST || action.type === DELETED_SAVED_LIST) {
    const revision = state.savedListRevision + 1;
    state = { ...state, savedListRevision: revision,
      savedListRevisionById: { ...state.savedListRevisionById, [action.payload.id]: revision } };
  }
  switch (action.type) {
    case ADD_SPEAKER_SUBSCRIBE_IDS:
      const addedSpeakerSubscribeStatusById = {
        ...state.speakerSubscribeStatusById,
        ...subscribeStatusMapFromIds(action.payload.speakerIds),
      };
      return {
        ...state,
        speakerSubscribeStatusById: addedSpeakerSubscribeStatusById,
        speakerSubscribeIds: addSpeakerSubscribeIds(state.speakerSubscribeIds, action.payload.speakerIds),
      };
    case ADD_TRACK_TO_SAVED_LIST:
      return update(state, {
        savedTrackIdToSavedListIds: {
          [action.payload.trackId]: {
            $push: [action.payload.listId]
          }
        }
      });
    case DELETED_SAVED_LIST:
      // Remove the saved list ID from all tracks in savedTrackIdToSavedListIds.
      // Remove entry from savedLists that matches the list ID.
      return update(state, {
        // savedTrackIdToSavedListIds is a mapping of track IDs to their saved list IDs.
        // action.payload.id is the list id that should be removed.
        savedTrackIdToSavedListIds: {
          $apply: (ids) => {
            const newIds = { ...ids };
            Object.keys(newIds).forEach((trackId) => {
              newIds[trackId] = newIds[trackId].filter((id) => id !== action.payload.id);
            });
            return newIds;
          }
        },
        // savedLists is a array of list objects with an "id" and a "name".
        savedLists: {
          $apply: (lists) => lists.filter((list) => list.id !== action.payload.id)
        }
      });
    case FOR_ME_LOADING_COUNT_DECREASE:
      if (action.payload?.uid && action.payload.uid !== state.uid) return state;
      if (action.payload?.sessionRevision !== undefined && action.payload.sessionRevision !== state.forMeSessionRevision) return state;
      return {
        ...state,
        forMeLoadingCount: Math.max(state.forMeLoadingCount - 1, 0),
      };
    case FOR_ME_LOADING_COUNT_INCREASE:
      if (action.payload?.uid && action.payload.uid !== state.uid) return state;
      if (action.payload?.sessionRevision !== undefined && action.payload.sessionRevision !== state.forMeSessionRevision) return state;
      return {
        ...state,
        forMeLoadingCount: state.forMeLoadingCount + 1,
        ...(action.payload?.uid ? { forMeLoadError: null } : {}),
      };
    case FOR_ME_LOAD_FAILED:
      if (action.payload.uid !== state.uid || action.payload.sessionRevision !== state.forMeSessionRevision ||
        action.payload.revision !== state.forMePreferenceRevision) return state;
      return { ...state, forMeLoadError: 'Couldn’t load your feed. Try again.' };
    case FOR_ME_PREFERENCE_SAVE_STARTED: {
      if (action.payload.uid !== state.uid) return state;
      return {
        ...state,
        forMePreferenceRevision: state.forMePreferenceRevision + 1,
        forMePreferenceSaves: { ...state.forMePreferenceSaves, [action.payload.token]: true },
        preparedForMeData: null,
        preparedForMeRevision: null,
        preferenceFeedRefreshState: state.preferenceFeedRefreshState === 'idle' ? 'idle' : 'refreshing',
      };
    }
    case FOR_ME_PREFERENCE_SAVE_FINISHED: {
      if (action.payload.uid !== state.uid || !state.forMePreferenceSaves[action.payload.token]) return state;
      const pending = { ...state.forMePreferenceSaves };
      delete pending[action.payload.token];
      const { succeeded, boostTopicId } = action.payload;
      return {
        ...state,
        forMePreferenceSaves: pending,
        forMePreferenceBoostTopicIds: succeeded && boostTopicId
          ? [...new Set([...state.forMePreferenceBoostTopicIds, boostTopicId])]
          : state.forMePreferenceBoostTopicIds,
        preferenceFeedRefreshState: succeeded ? 'refreshing' : state.preferenceFeedRefreshState,
      };
    }
    case FOR_ME_PREFERENCE_REFRESH_REQUESTED:
      if (action.payload.uid !== state.uid) return state;
      return { ...state, preferenceFeedRefreshState: 'refreshing', preparedForMeData: null, preparedForMeRevision: null };
    case FOR_ME_PREFERENCE_REFRESH_READY:
    case FOR_ME_PREFERENCE_REFRESH_FAILED: {
      if (action.payload.uid !== state.uid || action.payload.revision !== state.forMePreferenceRevision ||
        Object.keys(state.forMePreferenceSaves).length) return state;
      const ready = action.type === FOR_ME_PREFERENCE_REFRESH_READY;
      return {
        ...state,
        preferenceFeedRefreshState: ready ? 'ready' : 'failed',
        forMeLoadError: null,
        preparedForMeData: ready ? action.payload.data : null,
        preparedForMeRevision: ready ? action.payload.revision : null,
      };
    }
    case FOR_ME_PREFERENCE_REFRESH_APPLIED:
      if (action.payload.uid !== state.uid || state.preferenceFeedRefreshState !== 'ready' ||
        Object.keys(state.forMePreferenceSaves).length || state.preparedForMeRevision !== state.forMePreferenceRevision) return state;
      return {
        ...state,
        forMePreviewsData: {
          ...state.preparedForMeData,
          previews: state.preparedForMeData.previews.filter(preview => preview?.id && !state.forMeSeenPreviewIds[preview.id]),
          setTime: Date.now(),
        },
        preferenceFeedRefreshState: 'idle',
        forMeLoadError: null,
        preparedForMeData: null,
        preparedForMeRevision: null,
        forMePreferenceBoostTopicIds: [],
        forMeDismissedInitialPreviewIds: { ...state.forMeSeenPreviewIds },
      };
    case FOR_ME_PREVIEW_SEEN:
      if (action.payload.uid !== state.uid || !action.payload.previewId) return state;
      return { ...state, forMeSeenPreviewIds: { ...state.forMeSeenPreviewIds, [action.payload.previewId]: true } };
    case LOAD_TOPIC_PREFERENCES: {
      if (action.payload.uid !== state.uid) {
        return state;
      }
      return {
        ...state,
        topicPreferencesError: null,
        topicPreferencesLoading: true,
        topicPreferencesRequestId: action.payload.requestId,
      };
    }
    case LOAD_LATEST_SUBSCRIED:
      return {
        ...state,
        latestSubscribedLoading: true,
        latestSubscribedRefreshReason: action.payload?.reason || 'automatic',
        latestSubscribedError: false,
        latestSubscribedRequestId: action.payload?.requestId ?? null,
      };
    case LATEST_SUBSCRIBED_LOAD_FAILED:
      return {
        ...state,
        latestSubscribedLoading: false,
        latestSubscribedError: action.payload?.showError === true,
        latestSubscribedFailedAt: Date.now(),
        latestSubscribedRequestId: null,
      };
    case INVALIDATE_LATEST_SUBSCRIBED:
      return {
        ...state,
        latestSubscribedData: state.latestSubscribedData ? { ...state.latestSubscribedData, setTime: 0 } : null,
        latestSubscribedInvalidationRevision: state.latestSubscribedInvalidationRevision + 1,
        // A request started before the follow changed can no longer update this feed.
        latestSubscribedRequestId: null,
        latestSubscribedLoading: false,
        latestSubscribedError: false,
        latestSubscribedFailedAt: null,
      };
    case LOAD_RECENTLY_PLAYED:
      return {
        ...state,
        recentlyPlayedLoading: true,
      };
    case LOAD_RECENTLY_SAVED:
      return {
        ...state,
        recentlySavedLoading: true,
      };
    case REMOVE_TRACK_FROM_SAVED_LIST:
      return update(state, {
        savedTrackIdToSavedListIds: {
          [action.payload.trackId]: {
            $apply: (listIds) => listIds.filter((id) => id !== action.payload.listId)
          }
        }
      });
    case SAVE_TRACK_MUTATION_FINISHED:
      return {
        ...state,
        saveTrackMutationCount: Math.max(state.saveTrackMutationCount - 1, 0),
      };
    case SAVE_TRACK_MUTATION_STARTED:
      return {
        ...state,
        saveTrackMutationCount: state.saveTrackMutationCount + 1,
      };
    case SET_AUTHENTICATED:
      return {
        ...state,
        authenticated: true,
        authRestoreError: null,
      };
    case SET_AUTH_RESTORE_ERROR:
      return { ...state, authRestoreError: action.payload };
    case SET_FOR_ME:
      const forMePreviewsData = action.payload;
      if (forMePreviewsData) {
        forMePreviewsData.setTime = Date.now();
      }
      return {
        ...state,
        forMePreviewsData: forMePreviewsData,
        forMeLoadError: null,
      };
    case SET_GET_STARTED_TOPICS_STATUS_TRUE:
      return {
        ...state,
        getStartedTopicsStatus: true,
      };
    case SET_LATEST_SUBSCRIED:
      return {
        ...state,
        latestSubscribedData: action.payload ? { ...action.payload, setTime: Date.now() } : null,
        latestSubscribedLoading: false,
        latestSubscribedError: false,
        latestSubscribedFailedAt: null,
        latestSubscribedRequestId: null,
      };
    case SET_PODCAST_SUBSCRIBE_STATUS:
      const podcastSubscribeStatusById = applySubscribeStatus(
        state.podcastSubscribeStatusById,
        action.payload.subscribeId,
        action.payload.subscribeStatus,
      );
      return {
        ...state,
        podcastSubscribeStatusById,
        // Keep acknowledged neutral choices distinct from an entity we have not loaded.
        entityPreferenceEdits: { ...state.entityPreferenceEdits, [`source:${action.payload.subscribeId}`]: {
          status: action.payload.subscribeStatus,
          revision: (state.entityPreferenceEdits?.[`source:${action.payload.subscribeId}`]?.revision || 0) + 1,
        } },
        podcastSubscribeIds: subscribeIdsFromStatusById(podcastSubscribeStatusById),
      };
    case SET_RECENTLY_PLAYED:
      return {
        ...state,
        recentlyPlayedData: action.payload,
        recentlyPlayedLoading: false,
      };
    case SET_RECENTLY_SAVED:
      return {
        ...state,
        recentlySavedData: action.payload,
        recentlySavedLoading: false,
      };
    case SET_SPEAKER_SUBSCRIBE_STATUS:
      const speakerSubscribeStatusById = applySubscribeStatus(
        state.speakerSubscribeStatusById,
        action.payload.subscribeId,
        action.payload.subscribeStatus,
      );
      return {
        ...state,
        speakerSubscribeStatusById,
        entityPreferenceEdits: { ...state.entityPreferenceEdits, [`speaker:${action.payload.subscribeId}`]: {
          status: action.payload.subscribeStatus,
          revision: (state.entityPreferenceEdits?.[`speaker:${action.payload.subscribeId}`]?.revision || 0) + 1,
        } },
        speakerSubscribeIds: subscribeIdsFromStatusById(speakerSubscribeStatusById),
      };
    case SET_UNAUTHENTICATED:
      return {
        ...initialState,
        forMeSessionRevision: state.forMeSessionRevision + 1,
        authenticated: false
      };
    case SET_USER: {
      const normalizedUserState = normalizeUserSubscribeState(action.payload);
      const switchedUsers = Boolean(
        state.uid &&
        normalizedUserState.uid &&
        state.uid !== normalizedUserState.uid,
      );
      // A login request can overlap creating/deleting a shared emoji list.
      // Preserve only changes made after that request; a fresh login remains authoritative.
      if (!switchedUsers && Array.isArray(normalizedUserState.savedLists)) {
        const startedRevision = action.meta?.savedListStartedRevision ?? state.savedListRevision;
        const changedIds = new Set(Object.entries(state.savedListRevisionById)
          .filter(([, revision]) => revision > startedRevision).map(([id]) => id));
        const recentLists = state.savedLists.filter(list => changedIds.has(list.id));
        normalizedUserState.savedLists = [...recentLists,
          ...normalizedUserState.savedLists.filter(list => !changedIds.has(list.id))];
        const deletedIds = new Set([...changedIds].filter(id => !recentLists.some(list => list.id === id)));
        if (normalizedUserState.savedTrackIdToSavedListIds) {
          normalizedUserState.savedTrackIdToSavedListIds = Object.fromEntries(
            Object.entries(normalizedUserState.savedTrackIdToSavedListIds)
              .map(([id, lists]) => [id, lists.filter(listId => !deletedIds.has(listId))]));
        }
      }
      return {
        ...state,
        ...(switchedUsers ? { ...initialState, forMeSessionRevision: state.forMeSessionRevision + 1 } : {}),
        ...normalizedUserState,
      };
    }
    case SYNC_SUBSCRIBE_STATUSES:
      const syncedSpeakerSubscribeStatusById = applySubscribeStatusEntries(
        state.speakerSubscribeStatusById,
        action.payload.speakerSubscribeStatuses,
      );
      const syncedPodcastSubscribeStatusById = applySubscribeStatusEntries(
        state.podcastSubscribeStatusById,
        action.payload.podcastSubscribeStatuses,
      );
      return {
        ...state,
        speakerSubscribeStatusById: syncedSpeakerSubscribeStatusById,
        podcastSubscribeStatusById: syncedPodcastSubscribeStatusById,
        speakerSubscribeIds: subscribeIdsFromStatusById(syncedSpeakerSubscribeStatusById),
        podcastSubscribeIds: subscribeIdsFromStatusById(syncedPodcastSubscribeStatusById),
      };
    case SYNC_TOPIC_PREFERENCES: {
      if (action.payload.uid !== state.uid) {
        return state;
      }

      const replace = action.payload.replace === true;
      const topicStatuses = Array.isArray(action.payload.topicStatuses)
        ? action.payload.topicStatuses
        : [];
      let syncedTopicPreferenceStatusById = replace
        ? {}
        : { ...state.topicPreferenceStatusById };
      const nextRevision = state.topicPreferencesRevision + 1;
      const syncedRevisionById = { ...state.topicPreferenceRevisionById };

      topicStatuses.forEach((topicStatus) => {
        const topicId = typeof topicStatus?.topicId === 'string'
          ? topicStatus.topicId.trim()
          : '';
        if (!topicId) {
          return;
        }
        syncedTopicPreferenceStatusById = applySubscribeStatus(
          syncedTopicPreferenceStatusById,
          topicId,
          topicStatus.topicStatus,
        );
        syncedRevisionById[topicId] = nextRevision;
      });

      if (replace) {
        Object.keys(state.topicPreferencePendingMutationById).forEach((topicId) => {
          if (Object.prototype.hasOwnProperty.call(state.topicPreferenceStatusById, topicId)) {
            syncedTopicPreferenceStatusById[topicId] = state.topicPreferenceStatusById[topicId];
          } else {
            delete syncedTopicPreferenceStatusById[topicId];
          }
        });
      }

      return {
        ...state,
        topicPreferenceStatusById: syncedTopicPreferenceStatusById,
        topicPreferencesError: replace ? null : state.topicPreferencesError,
        topicPreferencesLoaded: replace ? true : state.topicPreferencesLoaded,
        topicPreferencesLoading: replace ? false : state.topicPreferencesLoading,
        topicPreferencesRequestId: replace ? null : state.topicPreferencesRequestId,
        topicPreferencesRevision: nextRevision,
        topicPreferenceRevisionById: syncedRevisionById,
      };
    }
    case TOPIC_PREFERENCE_MUTATION_FINISHED: {
      if (action.payload.uid !== state.uid) {
        return state;
      }
      const currentMutation = state.topicPreferencePendingMutationById[action.payload.topicId];
      if (currentMutation?.mutationId !== action.payload.mutationId) {
        return state;
      }
      const nextPendingMutationById = { ...state.topicPreferencePendingMutationById };
      delete nextPendingMutationById[action.payload.topicId];
      return {
        ...state,
        topicPreferencePendingMutationById: nextPendingMutationById,
      };
    }
    case TOPIC_PREFERENCE_MUTATION_ROLLED_BACK: {
      if (action.payload.uid !== state.uid) {
        return state;
      }
      const currentMutation = state.topicPreferencePendingMutationById[action.payload.topicId];
      if (currentMutation?.mutationId !== action.payload.mutationId) {
        return state;
      }

      const nextRevision = state.topicPreferencesRevision + 1;
      const rolledBackStatusById = { ...state.topicPreferenceStatusById };
      if (action.payload.previousHadStatus) {
        rolledBackStatusById[action.payload.topicId] = action.payload.previousStatus;
      } else {
        delete rolledBackStatusById[action.payload.topicId];
      }
      const nextPendingMutationById = { ...state.topicPreferencePendingMutationById };
      delete nextPendingMutationById[action.payload.topicId];

      return {
        ...state,
        topicPreferenceStatusById: rolledBackStatusById,
        topicPreferencesRevision: nextRevision,
        topicPreferenceRevisionById: {
          ...state.topicPreferenceRevisionById,
          [action.payload.topicId]: nextRevision,
        },
        topicPreferencePendingMutationById: nextPendingMutationById,
      };
    }
    case TOPIC_PREFERENCE_MUTATION_STARTED: {
      if (action.payload.uid !== state.uid) {
        return state;
      }
      const nextRevision = state.topicPreferencesRevision + 1;
      return {
        ...state,
        topicPreferenceStatusById: applySubscribeStatus(
          state.topicPreferenceStatusById,
          action.payload.topicId,
          action.payload.topicStatus,
        ),
        topicPreferencesRevision: nextRevision,
        topicPreferenceRevisionById: {
          ...state.topicPreferenceRevisionById,
          [action.payload.topicId]: nextRevision,
        },
        topicPreferencePendingMutationById: {
          ...state.topicPreferencePendingMutationById,
          [action.payload.topicId]: {
            mutationId: action.payload.mutationId,
            revision: nextRevision,
          },
        },
      };
    }
    case TOPIC_PREFERENCES_LOAD_FAILED: {
      if (
        action.payload.uid !== state.uid ||
        action.payload.requestId !== state.topicPreferencesRequestId
      ) {
        return state;
      }
      return {
        ...state,
        topicPreferencesError: action.payload.error,
        topicPreferencesLoading: false,
        topicPreferencesRequestId: null,
      };
    }
    case TOPIC_PREFERENCES_LOADED: {
      if (
        action.payload.uid !== state.uid ||
        action.payload.requestId !== state.topicPreferencesRequestId
      ) {
        return state;
      }

      const loadedStatusById = normalizeSubscribeStatusById(action.payload.statusById);
      Object.entries(state.topicPreferenceRevisionById).forEach(([topicId, revision]) => {
        const mutationPending = Boolean(state.topicPreferencePendingMutationById[topicId]);
        if (revision <= action.payload.startedRevision && !mutationPending) {
          return;
        }
        if (Object.prototype.hasOwnProperty.call(state.topicPreferenceStatusById, topicId)) {
          loadedStatusById[topicId] = state.topicPreferenceStatusById[topicId];
        } else {
          delete loadedStatusById[topicId];
        }
      });

      return {
        ...state,
        topicPreferenceStatusById: loadedStatusById,
        topicPreferencesError: null,
        topicPreferencesLoaded: true,
        topicPreferencesLoading: false,
        topicPreferencesRequestId: null,
      };
    }
    case SET_SAVE_TRACK_STATUS:
      if (action.payload.saveStatus) {
        return update(state, {
          savedTrackIdToSavedListIds: {
            [action.payload.trackId]: {
              $set: action.payload.savedListIds ?? []
            }
          }
        });
      } else {
        return update(state, {
          savedTrackIdToSavedListIds: {
            $unset: [action.payload.trackId]
          }
        });
      }
    case UPDATED_SAVED_LIST:
      const index = state.savedLists.findIndex(
        list => list.name === action.payload.name,
      );

      // If the list exists, remove it first
      if (index !== -1) {
        return update(state, {
          savedLists: {
            $splice: [
              // Remove 1 item starting from 'index'
              [index, 1],
              // Then prepend the new item at the beginning
              [0, 0, { name: action.payload.name, id: action.payload.id }],
            ],
          },
        });
      }

      // If the list doesn't exist, just add it to the beginning
      return update(state, {
        savedLists: {
          $unshift: [
            {
              name: action.payload.name,
              id: action.payload.id,
            },
          ],
        },
      });
    default:
      return state;
  }
}
